<div libCalculateEllipsis
	 [lines]="lines"
	 [lineHeight]="lineHeight"
	 *transloco="let t; read: 'textWithEllipsis'">
	<p class="full-content" [innerHTML]="sanitizedContent" [ngClass]="{hidden: overflowHidden}">{{ content }}</p>
	<p class="with-ellipsis" [ngClass]="{hidden: !overflowHidden}"></p>
	<button id="showButton" (click)="hideExpandContent()"
			[ngClass]="{hidden: hideShowMoreBtn || !overflowHidden}">
		{{ t('showMore') | lowercase }}</button>
	<button id="hideButton"
			(click)="hideExpandContent()"
			[ngClass]="{hidden: hideShowMoreBtn || overflowHidden}">
		{{ t('showLess') | lowercase }}</button>
</div>
